import { Component, Input, OnInit } from '@angular/core';
import { cloneDeep } from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { coverageDTO, coverageDTOModal } from 'src/app/models/coverageDTO';
import { CalculationsControlService } from 'src/app/services/calculations-control.service';
import { MapService } from 'src/app/services/map.service';
import { NavaidsCoChannelsService } from 'src/app/services/navaids-co-channels.service';
import { PointsService } from 'src/app/services/points.service';
import { TabsService } from 'src/app/services/tabsService';

@Component({
  selector: 'popup-area-coverage',
  templateUrl: './area-coverage.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class PopupAreaCoverageComponent implements OnInit {

  @Input() title : string;
  @Input() coverage_type : string;
  isSingleLevelDisabled : boolean = true;
  readonly forbiddenSubstringName = TabsService.SEPARATOR;

  constructor(public calculationControlService : CalculationsControlService,
    public mapService : MapService,
    public pointsController : PointsService,
    public bsModalRef : BsModalRef,
    private navaidsCoChannelService : NavaidsCoChannelsService) {
    this.calculationControlService.coverageDTO = new coverageDTO();
    this.calculationControlService.coverageDTOModal = new coverageDTOModal();
  }

  ngOnInit(): void {
    this.calculationControlService.getCoverageDefaultAltitudes();
  }

  calculate() : void {
    if( this.coverage_type == "COVERAGE"){
      this.coverageCalculation();
    }else if(this.coverage_type == "OVERLAP"){
      this.overlapCalculation();
    }else {
      this.cumulativeCoverageCalculation()
    }
  }

  coverageCalculation(): void{
    this.calculationControlService.coverageCalculationInitialization();
    this.bsModalRef.hide();
  }

  cumulativeCoverageCalculation(): void{
    this.calculationControlService.cumulativeCoverageCalculationInitialization();
    this.bsModalRef.hide();
  }

  overlapCalculation(): void{
    this.calculationControlService.overlapCalculationInitialization(cloneDeep(this.navaidsCoChannelService.previousSelectedNavaids));
    this.bsModalRef.hide();
  }

  cancelCoverage():void{
    this.bsModalRef.hide();
  }

  changeSelection():void{
    this.isSingleLevelDisabled = !this.isSingleLevelDisabled;
    this.calculationControlService.coverageDTOModal.isSingleLevel = !this.calculationControlService.coverageDTOModal.isSingleLevel;
    this.calculationControlService.getCoverageDefaultAltitudes();
  }
}
